export var getSeoDescription = function getSeoDescription(item) {
  if (item === void 0) {
    item = {};
  }

  return item.event && (item.event.description || item.event.about);
};